import './home.scss';

import React from 'react';
import {Col, Row} from 'reactstrap';
import {Button} from 'edozvola-frontend-lib/dist/ui/components';
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {faCircleQuestion} from "@fortawesome/free-regular-svg-icons";
import {useAccessibility} from "app/shared/accessibility/accessiblity.provider";
import {AccessibilityContrastEnum} from "app/shared/accessibility/accessibility.enum";
import {onDownloadContentFile} from "app/shared/util/redozvola-util";

export const Home = () => {

  const { contrast } = useAccessibility();

  const onDownloadInstruction = (e) => {
    onDownloadContentFile(e,
      "content/pdf/edozvola_upute.pdf",
      "Korisničke upute - eDozvola - javni portal.pdf"
    );
  }

  return (
    <div className="container-fluid view-container bg-white justify-content-center">
      <Row>
        <Col className={'d-flex justify-content-center mb-5'}>
          <img style={{maxWidth: '360px', minHeight: '360px'}} src={`content/images/${contrast === AccessibilityContrastEnum.IMPAIRED ? 'homepage-hc' : 'homepage'}.png`} />
        </Col>
      </Row>
      <Row>
          <Col className={'d-flex justify-content-center mb-2'}>
            <span className={'h6'}>MINISTARSTVO PROSTORNOGA UREĐENJA, GRADITELJSTVA I DRŽAVNE IMOVINE</span>
          </Col>
      </Row>
      <Row>
          <Col className={'d-flex justify-content-center mb-2'}>
            <h3>Dobro došli u informacijski sustav eGrađevinska dozvola i druge usluge u gradnji</h3>
          </Col>
      </Row>
      <Row className={'d-flex justify-content-center'} style={{marginRight: '15%', marginLeft: '15%'}}>
          <Col style={{color: '#888c94'}} className={'d-flex justify-content-center text-center mb-5 text-gray'}>
            <span>Ova usluga omogućava izdavanje akata za građenje tj. vođenje postupaka temeljem Zakona o prostornom uređenju i Zakona o gradnji. Za sve nejasnoće ili poteškoće prilikom predaje zahtjeva molimo Vas obratite se korisničkoj službi na e-mail adresu <a href={'mailto:eDozvola-info@mpgi.hr'}>eDozvola-info@mpgi.hr</a>.</span>
          </Col>
      </Row>
      <Row>
          <Col className={'d-flex justify-content-center'}>
            <Button onClick={(e) => onDownloadInstruction(e)} label={'Korisničke upute'} prependIcon={faCircleQuestion as IconDefinition} size={'lg'} color={'info'} />
          </Col>
      </Row>
    </div>
  );
};

export default Home;
